module.exports = __webpack_public_path__ + "img/icon-DoNotStretch-mh.fcae930f.png";